import { render, staticRenderFns } from "./BankTransfer.vue?vue&type=template&id=54dacdd8"
import script from "./BankTransfer.vue?vue&type=script&lang=ts"
export * from "./BankTransfer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports